import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bold: {
    defaultMessage: 'Bold',
    description: 'Apply bold weight to selected text',
  },
  italic: {
    defaultMessage: 'Italic',
    description: 'Apply italic style to selected text',
  },
  underline: {
    defaultMessage: 'Underline',
    description: 'Underline selected text',
  },
  strikethrough: {
    defaultMessage: 'Strikethrough',
    description: 'Draw a line through selected text',
  },
  clearFormatting: {
    defaultMessage: 'Clear formatting',
    description:
      'Remove text styles and block formatting from selected content',
  },
  bulletList: {
    defaultMessage: 'Bullet list',
    description: 'Format content as an unordered list',
  },
  orderedList: {
    defaultMessage: 'Ordered list',
    description: 'Format content as a numbered list',
  },
  quote: {
    defaultMessage: 'Quote',
    description: 'Format content as a block quotation',
  },
  removeLink: {
    defaultMessage: 'Remove link',
    description: 'Remove the hyperlink from selected text',
  },
  addLink: {
    defaultMessage: 'Add link',
    description: 'Insert a hyperlink into rich text',
  },
  uploadImage: {
    defaultMessage: 'Upload image (or drag & drop)',
    description: 'Add an image file to rich text by uploading or dragging it',
  },
  imageFromUrl: {
    defaultMessage: 'Add image from URL',
    description: 'Embed an image in rich text using its web address',
  },
  workerAttribute: {
    defaultMessage: 'Insert worker attribute',
    description:
      'Insert a placeholder for a worker profile field into a message',
  },
  undo: {
    defaultMessage: 'Undo',
    description: 'Reverse the most recent text edit',
  },
  redo: {
    defaultMessage: 'Redo',
    description: 'Restore the most recently undone text edit',
  },
  linkText: {
    defaultMessage: 'Link text',
    description: 'Text displayed for a hyperlink',
  },
  linkTextPlaceholder: {
    defaultMessage: 'Enter text to display',
    description: 'Prompt for the visible text of a hyperlink',
  },
  url: {
    defaultMessage: 'URL',
    description: 'Destination web address for a hyperlink',
  },
  imageUrl: {
    defaultMessage: 'Image URL',
    description: 'Web address of an image to embed in rich text',
  },
  placeholder: {
    defaultMessage: 'Start typing',
    description: 'Prompt to enter content in an empty rich-text field',
  },
  backgroundColor: {
    defaultMessage: 'Background color picker',
    description:
      'Choose the background color of a clickable button in a message',
  },
});
